// extracted by mini-css-extract-plugin
export default {"scrollToBottomButton":"ScrollToBottomButton_scrollToBottomButton__c35Px","show":"ScrollToBottomButton_show__7p39N"};